import { useCallback, useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import { BsPlusLg } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Booking } from "../booking-page/store/slice";
import bookingPageSlice from "../booking-page/store/slice";
import styles from "./bookingMeta.module.scss";
import { useCountUp } from "react-countup";
import { Pagination } from "../../utils/api";

type Props = { data: Booking[]; meta: Pagination | null };

const BookingMeta = ({ data, meta }: Props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const profile = useSelector((state) => state.loginPage.profile);

  const { reset, update } = useCountUp({
    ref: "counter",
    end: 0,
    duration: 1,
  });

  const setIsFiltersOpened = useCallback(
    (opened: boolean) =>
      dispatch(bookingPageSlice.actions.setIsFiltersOpened(opened)),
    [dispatch]
  );

  useEffect(() => {
    if (data.length > 0) {
      update(data.length);
    } else {
      reset();
    }
  }, [data, update, reset]);

  if (!profile) return null;

  return (
    <Card className={styles.card}>
      <Card.Body className={styles.body}>
        <div className={styles.totalFound}>
          <div>
            <span>Bookings showed:</span>
            <small>
              Matching your{" "}
              <Link to="#" onClick={() => setIsFiltersOpened(true)}>
                default filters
              </Link>
              .
            </small>
          </div>
          <div>
            <span id="counter" />
            <small>/ {meta ? meta.total : "0"}</small>
          </div>
        </div>
        <div className={styles.addBooking}>
          <Button
            onClick={() =>
              navigate("new", { state: { backgroundLocation: location } })
            }
            variant="success"
            disabled={profile.companies[0] && profile.companies[0].restricted}
          >
            <BsPlusLg />
            Add booking
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default BookingMeta;
